export class JanglTextareaController {
    $onInit() {
        if (!this.name) throw new Error('Textareas must have a name attribute');
        if (!this.label) throw new Error(this.name + ': label attribute must be set');
        if (!this.hasOwnProperty('model')) throw new Error(this.name + ': model attribute must be set.');
        this._errorMessages = angular.copy(this.errorMessages) || [];

        if (!this._errorMessages.find((item) => { return (item.type == 'required')})) {
            this._errorMessages.push({type: 'required', msg: this.label + ' is required.'});
        }
    }
}
JanglTextareaController.$inject = [];

export default JanglTextareaController;


// WEBPACK FOOTER //
// ./app/jangl/jangl-textarea/controller.js